import React from 'react';
import { FoldingLogos } from '../Components/FoldingLogos';
import HeroSection from '../Components/AboutHero';
import InteractiveTimeline from '../Components/InteractiveTimeline';
import { Helmet } from "react-helmet";

const About = () => {
  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://plambech.dev/"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "About",
        "item": "https://plambech.dev/about"
      }
    ]
  };

  const timeline = [
    {
      year: "2024-Current",
      title: "Plambech Development",
      role: "Founder / Freelance Developer",
      description: "Being a seasoned freelance web developer with over 11 years of experience, I decided to start my own company so I can work more closely with clients and create better, longer–term results.\n\nIn agencies, I often missed being part of the full journey — getting to know a client, building something great together, and then suddenly handing them off to a support team. I prefer to stay involved, understand the business over time, and continuously improve what we've built.\n\nToday, I typically join companies as a semi-permanent freelance partner, while still being open to shorter one-off projects when it makes sense. I specialize in building fast, scalable, and SEO-friendly websites and platforms using WordPress, PHP, JavaScript, and modern SEO practices."
    },
    {
      year: "2022-2024",
      title: "Logpoint",
      role: "Senior WordPress Developer",
      description: "Responsible for developing and maintaining company websites, integrating CRM systems, managing servers, optimizing performance, and overseeing tracking and reporting functionalities."
    },
    {
      year: "2021-2022",
      title: "Bærnholdt",
      role: "WordPress Developer",
      description: "Provided agency services to large clients, developing custom WordPress solutions to meet the specific needs of high-profile customers."
    },
    {
      year: "2018-2021",
      title: "Waimea Digital",
      role: "WordPress Developer & Associate Partner",
      description: "Focused on developing websites and webshops for large enterprise clients, dedicating efforts to delivering high-quality web solutions."
    },
    {
      year: "2016-2018",
      title: "Bravo Media",
      role: "Frontend Developer",
      description: "Worked on WordPress sites by creating themes, modifying and expanding plugins, and performing maintenance tasks."
    },
    {
      year: "2013-2016",
      title: "Computerpeople",
      role: "Web Designer",
      description: "Responsible for graphical site design using Photoshop and front-end programming in Java-based CMS, WordPress and Joomla."
    }
  ];

  return (
    <div className="bg-white">
      <Helmet>
        <title>About Rasmus Plambech | Experienced Freelance Developer</title>
        <meta name="description" content="Rasmus Plambech is a seasoned freelance developer with over 11 years of experience in WordPress, PHP, JavaScript, and SEO—crafting high-performance websites that drive business growth." />
        <link rel="canonical" href="https://plambech.dev/about" />

        {/* Open Graph Tags */}
        <meta property="og:title" content="About Rasmus Plambech | Experienced Freelance Developer" />
        <meta property="og:description" content="Rasmus Plambech is a seasoned freelance developer with over 11 years of experience in WordPress, PHP, JavaScript, and SEO—crafting high-performance websites that drive business growth." />
        <meta property="og:url" content="https://plambech.dev/about" />

        {/* Twitter Card Tags */}
        <meta name="twitter:title" content="About Rasmus Plambech | Experienced Freelance Developer" />
        <meta name="twitter:description" content="Rasmus Plambech is a seasoned freelance developer with over 11 years of experience in WordPress, PHP, JavaScript, and SEO—crafting high-performance websites that drive business growth." />

        {/* Breadcrumb Schema */}
        <script type="application/ld+json">
          {JSON.stringify(breadcrumbSchema)}
        </script>
      </Helmet>

      <HeroSection />

      {/* Interactive Timeline Section */}
      <InteractiveTimeline timeline={timeline} />

      <FoldingLogos />
    </div>
  );
};

export default About;